






































































































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Select, Option } from '@/models/Configurator';

@Component
export default class ConfigSelect extends Vue {
    @Prop() variants!: Select;
    @Prop() value!: Array<Option>;
    @Prop({ default: '' }) currency!: string;
    expanded: boolean = false;
    constructor() {
        super();
        //  this.value = this.variants.options[0];
        // console.log(this.value);
    }
    private unexpand(e: FocusEvent) {
        if (e.relatedTarget == null || !this.$el.contains(e.relatedTarget as Node)) {
            this.expanded = false;
        }
    }

    private expand(e: PointerEvent, selectedList: Select) {
        const elem = e.target as HTMLElement;
        if (elem.classList.contains('config-select__info-hinging-icon')) this.$emit('showModal', selectedList);
        else this.$emit('selectedList', selectedList);
    }

    private selectOption(val: Option, variants: Select) {
        if (variants.type === 'Sink') {
            this.$emit('setQuantity', val.quantityFaucets);
        }
        if (variants.type === 'DoorHinging') {
            this.$emit('setDoorHinging', val.name);
        }
        if (!variants.isMultiSelect) {
            this.value.shift();
            this.$emit('input', this.value.concat(val));
        } else {
            this.$emit(
                'input',
                this.value.indexOf(val) !== -1
                    ? this.value.filter(x => x.systemId !== val.systemId)
                    : this.value.concat(val)
            );
        }
    }

    private rowTotalCampaignPrice(options: Array<Option>): number {
        return options.reduce((prevVal: number, opt: Option) => {
            if (opt.campaignPrice && typeof opt.campaignPrice !== 'undefined')
                return prevVal + opt.campaignPrice * opt.quantity;
            else return prevVal + opt.price * opt.quantity;
        }, 0);
    }
    private rowTotalPrice(options: Array<Option>): number {
        return options.reduce((prevVal: number, opt: Option) => {
            return prevVal + opt.price * opt.quantity;
        }, 0);
    }

    private removeOption() {
        this.$emit('input', []);
    }
    private enter(element: HTMLElement) {
        const width = getComputedStyle(element).width;

        element.style.width = width;
        element.style.position = 'absolute';
        element.style.visibility = 'hidden';
        element.style.height = 'auto';

        const height = getComputedStyle(element).height;

        element.style.width = '';
        element.style.position = '';
        element.style.visibility = '';
        element.style.height = '0';
        getComputedStyle(element).height;
        requestAnimationFrame(() => {
            element.style.height = height;
        });
    }
    private afterEnter(element: HTMLElement) {
        element.style.height = 'auto';
    }
    private leave(element: HTMLElement) {
        const height = getComputedStyle(element).height;

        element.style.height = height;
        getComputedStyle(element).height;
        requestAnimationFrame(() => {
            element.style.height = '0';
        });
    }
}
